export default class PlannerProductNotes {
  cardNotes: string;
}
